// extracted by mini-css-extract-plugin
export var buttons = "_33-0";
export var buttonsActive = "_33-h";
export var cancelConfirm = "_33-1";
export var closeButton = "_33-2";
export var column = "_33-3";
export var container = "_33-4";
export var detailHeader = "_33-6";
export var detailTitle = "_33-7";
export var detailsContent = "_33-5";
export var header = "_33-8";
export var headerWithClose = "_33-9";
export var icon = "_33-a";
export var infoIcon = "_33-c";
export var informationContainer = "_33-b";
export var sideDrawer = "_33-d";
export var sideDrawerOpen = "_33-e";
export var stickyFooter = "_33-f";
export var typeOption = "_33-g";